import React, { useState } from 'react';

const ForgotPasswordHoc = (Component: any) => 
function Comp(props: any){
    const [showForgotPasswordPopup,setShowForgotPasswordPopup] = useState<boolean>(false);

    const forgotPasswordToggleHandler = () => {
        setShowForgotPasswordPopup(!showForgotPasswordPopup);
    }
	
	return <Component showForgotPasswordPopup={showForgotPasswordPopup} forgotPasswordToggleHandler={forgotPasswordToggleHandler} {...props} />;
};

export default ForgotPasswordHoc;